export default "__VITE_ASSET__8a5c8be9__"